import formatGroupedValues from "../utils/formatGroupedValues";
import capitalizeFilterLabel from "../utils/capitalizeFilterLabel";
import React from "react";
import FilterField from "../fields/FilterField";
import FilterMultiSelect from "../fields/FilterMultiSelect";
import FilterSelect from "../fields/FilterSelect";

export const TEMP_STAFF_FILES_SORT_OPTIONS = [
  { value: "name", label: "Name" },
  { value: "state", label: "State" },
  { value: "type", label: "Type" },
  { value: "create_date", label: "Created" },
];

export const TEMP_STAFF_FILE_STATUS_OPTIONS = [
  { value: "active", label: "Active" },
  { value: "inactive", label: "Inactive" },
  { value: "pending-review", label: "Pending Review" },
];

export const TEMP_STAFF_FILES_DEFAULT_FILTERS = {
  fileTypeFilters: [],
  statusFilters: [],
  sortBy: "name",
  sortDirection: "asc",
};

export function buildTempStaffFilesFilterChips({
  fileTypeFilters = [],
  statusFilters = [],
  fileTypeOptions = [],
}) {
  const chips = [];
  if (fileTypeFilters.length > 0) {
    const labelFor = (value) =>
      fileTypeOptions.find((o) => o.value === value)?.label || value;
    chips.push({
      id: "types",
      key: "fileTypeFilters",
      fieldId: "temp-staff-files-type",
      label: `Type: ${formatGroupedValues(fileTypeFilters, labelFor, 3)}`,
    });
  }
  if (statusFilters.length > 0) {
    chips.push({
      id: "status",
      key: "statusFilters",
      fieldId: "temp-staff-files-status",
      label: `Status: ${formatGroupedValues(statusFilters, capitalizeFilterLabel, 3)}`,
    });
  }
  return chips;
}

function FieldWrapper({ fieldId, label, focusedFieldId, onFocusClear, children }) {
  return (
    <FilterField
      id={fieldId}
      label={label}
      focusedFieldId={focusedFieldId}
      onFocusClear={onFocusClear}
    >
      {children}
    </FilterField>
  );
}

export default function TempStaffFilesFilterFields({
  focusedFieldId,
  onFocusClear,
  fileTypeOptions = [],
  fileTypeFilters = [],
  setFileTypeFilters,
  statusFilters = [],
  setStatusFilters,
  sortBy = "name",
  setSortBy,
  sortDirection = "asc",
  setSortDirection,
}) {
  return (
    <>
      <FieldWrapper
        fieldId="temp-staff-files-type"
        label="Type"
        focusedFieldId={focusedFieldId}
        onFocusClear={onFocusClear}
      >
        <FilterMultiSelect
          id="temp-staff-files-type"
          options={fileTypeOptions}
          value={fileTypeFilters}
          onChange={setFileTypeFilters}
          placeholder="Select…"
        />
      </FieldWrapper>

      <FieldWrapper
        fieldId="temp-staff-files-status"
        label="Status"
        focusedFieldId={focusedFieldId}
        onFocusClear={onFocusClear}
      >
        <FilterMultiSelect
          id="temp-staff-files-status"
          options={TEMP_STAFF_FILE_STATUS_OPTIONS}
          value={statusFilters}
          onChange={setStatusFilters}
          placeholder="Select…"
        />
      </FieldWrapper>

      <FieldWrapper
        fieldId="temp-staff-files-sort-by"
        label="Sort By"
        focusedFieldId={focusedFieldId}
        onFocusClear={onFocusClear}
      >
        <FilterSelect
          id="temp-staff-files-sort-by"
          value={sortBy}
          onChange={setSortBy}
          options={TEMP_STAFF_FILES_SORT_OPTIONS}
          placeholder={null}
        />
      </FieldWrapper>

      <FieldWrapper
        fieldId="temp-staff-files-sort-direction"
        label="Sort Direction"
        focusedFieldId={focusedFieldId}
        onFocusClear={onFocusClear}
      >
        <FilterSelect
          id="temp-staff-files-sort-direction"
          value={sortDirection}
          onChange={setSortDirection}
          options={[
            { value: "asc", label: "Ascending" },
            { value: "desc", label: "Descending" },
          ]}
          placeholder={null}
        />
      </FieldWrapper>
    </>
  );
}
